import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full truncate" }

import { ChevronDown } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import {
        DropdownMenu,
        DropdownMenuContent,
        DropdownMenuItem,
        DropdownMenuLabel,
        DropdownMenuSeparator,
        DropdownMenuTrigger,
    } from '@/components/ui/dropdown-menu';
    import { VoucherStatement } from '@/types';
    import { popupCenterDual } from '@/utils/helpers';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadStatements',
  props: {
    statement: {}
  },
  setup(__props: any) {

    const props = __props;

    const download = (fileId: number) => {
        popupCenterDual(
            route('v2.voucher.statement.file.download', {
                voucherStatementId: props.statement.id,
                fileId,
            }),
            props.statement.id.toString(),
            window.innerWidth / 2,
            window.innerHeight / 1.1,
        );
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenu), null, {
    default: _withCtx(() => [
      _createVNode(_unref(DropdownMenuTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "continue",
            size: "xs"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('button-text.display-statement')) + " ", 1),
              _createVNode(_unref(ChevronDown), { class: "h-4 w-4" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DropdownMenuContent), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statement.files_without_data, (file) => {
            return (_openBlock(), _createBlock(_unref(DropdownMenuItem), {
              key: file.id,
              onClick: ($event: any) => (download(file.id)),
              class: "max-w-[200px]"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(file.original_filename), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})